import request from '@/utils/request'


// 查询挑战赛奖池配置列表
export function listAward(query) {
  return request({
    url: '/award/award/list',
    method: 'get',
    params: query
  })
}

// 查询挑战赛奖池配置分页
export function pageAward(query) {
  return request({
    url: '/award/award/page',
    method: 'get',
    params: query
  })
}

// 查询挑战赛奖池配置详细
export function getAward(data) {
  return request({
    url: '/award/award/detail',
    method: 'get',
    params: data
  })
}

// 新增挑战赛奖池配置
export function addAward(data) {
  return request({
    url: '/award/award/add',
    method: 'post',
    data: data
  })
}

// 修改挑战赛奖池配置
export function updateAward(data) {
  return request({
    url: '/award/award/edit',
    method: 'post',
    data: data
  })
}

// 删除挑战赛奖池配置
export function delAward(data) {
  return request({
    url: '/award/award/delete',
    method: 'post',
    data: data
  })
}
